var api = require("!../../../../react/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../react/node_modules/css-modules-typescript-loader/index.js!../../../../react/node_modules/css-loader/dist/cjs.js??ref--6-2!../../../../react/node_modules/postcss-loader/src/index.js??ref--6-3!../../../../react/node_modules/sass-loader/dist/cjs.js??ref--6-4!./carousel.old.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};